import { useState } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { CardImages } from 'matrix';
import { Loading } from 'components/new-components/Loading';
import { DEFAULT_IMAGE, DEFAULT_IMAGE_BASE64 } from 'constants/index';
import * as El from './CityCard.css';

interface CityCardProps {
  images: CardImages;
  label: string;
  href: string;
  uuid: string;
  sectionPosition?: string;
  dataCreative?: string;
  loadingImage?: 'lazy' | 'eager'
}

function CityCard({
  images,
  label = '',
  href = '#',
  uuid,
  sectionPosition = '',
  dataCreative = '',
  loadingImage = 'eager',
}: CityCardProps) {
  const [hasClicked, setHasClicked] = useState(false);

  return (
    <Link
      className={`${El.cardLink} sympla-city-card`}
      href={href}
      title={label}
      onClick={() => setHasClicked(true)}
      target="_top"
      aria-label={label}
      data-bannerid={`${uuid}`}
      data-name={`${label}`}
      data-position={`${sectionPosition}`}
      data-creative={dataCreative}
    >
      <div className={El.cityCardContainer}>
        {hasClicked && (
          <div className={`${El.cityCardLoading} animated fadeIn`}>
            <Loading />
          </div>
        )}
        <div className={El.cityCardImageOverlay}>
          <Image
            src={images.xs || images.lg || images.banner || DEFAULT_IMAGE}
            alt={`Imagem ${label}`}
            className={El.cityCardImage}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 830px) 50vw, 25vw"
            loading={loadingImage}
            priority={loadingImage === 'eager'}
            placeholder="blur"
            blurDataURL={DEFAULT_IMAGE_BASE64}
            quality={80}
          />
        </div>
        <div className={`${El.cityName} animated fadeIn`}>{label}</div>
      </div>
    </Link>
  );
}

export default CityCard;
